import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HttpClient, HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ToastrModule } from 'ngx-toastr';
import {HttpTenantInterceptor} from "./core/interceptors/http.interceptor";
import {HttpCancelInterceptor} from "./core/interceptors/http-cancel.interceptor";
import {AuthService} from "./core/services/auth-service/auth.service";
import {OnlyAlphabetsDirective} from "./core/directives/only-alphabets.directive";
import {BsModalComponent} from "./component/bs-modal/bs-modal.component";
import {AppLoaderComponent} from "./component/app-loader/app-loader.component";
import {JWT_OPTIONS, JwtHelperService} from "@auth0/angular-jwt";
import {NgApexchartsModule} from "ng-apexcharts";
import {UserResetPasswordComponent} from "./pages/admin/users-roles/user-reset-password/user-reset-password.component";
import {BootstrapModalComponent} from "./component/bootstrap-modal/bootstrap-modal.component";
import {ReactiveFormsModule} from "@angular/forms";


function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      //authService.getUserByToken().subscribe().add();
        resolve(true)
    });
  };
}

@NgModule({
  declarations: [AppComponent],
  exports:[OnlyAlphabetsDirective],
    imports: [
        ToastrModule.forRoot({
            timeOut: 5500,
            extendedTimeOut: 5500,
            positionClass: 'toast-top-right',
            progressBar: true,
            preventDuplicates: true
        }),
        HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot(),
        ClipboardModule,
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        SweetAlert2Module.forRoot(),
        OnlyAlphabetsDirective,
        BsModalComponent,
        AppLoaderComponent,
        NgApexchartsModule,
        BootstrapModalComponent,
        ReactiveFormsModule,
        UserResetPasswordComponent
    ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService,HttpClient],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass:HttpTenantInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCancelInterceptor,
      multi: true
    },
      JwtHelperService,
      { provide: JWT_OPTIONS, useValue: {}}
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
